import { Injectable } from '@angular/core';

const SESSION_KEY_PREFIX = 'session_';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  get(key: string): string {
    return localStorage.getItem(key) ?? '';
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  setLessonSession(lessonId: string, value: string): void {
    localStorage.setItem(SESSION_KEY_PREFIX + lessonId, value);
  }

  getLessonSession(lessonId: string): string {
    return localStorage.getItem(SESSION_KEY_PREFIX + lessonId) ?? '';
  }

  clearAuthData(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('selectedOrganization');
    Object.keys(localStorage)
      .filter(key => key.startsWith(SESSION_KEY_PREFIX))
      .forEach(key => localStorage.removeItem(key));
  }
}
